module.exports = __webpack_public_path__ + "assets/img/index-product4.4f21219c.png";